__turbopack_context__.v({
  "buttonAndContainer": "PrivateUserProfileBadge-module-scss-module__78kc3G__buttonAndContainer",
  "contactButton": "PrivateUserProfileBadge-module-scss-module__78kc3G__contactButton",
  "container": "PrivateUserProfileBadge-module-scss-module__78kc3G__container",
  "message": "PrivateUserProfileBadge-module-scss-module__78kc3G__message",
  "name": "PrivateUserProfileBadge-module-scss-module__78kc3G__name",
  "rating": "PrivateUserProfileBadge-module-scss-module__78kc3G__rating",
  "small": "PrivateUserProfileBadge-module-scss-module__78kc3G__small",
  "text_container": "PrivateUserProfileBadge-module-scss-module__78kc3G__text_container",
});
